import React from 'react'
import {Menu} from "../Header/menu";
import {Link} from "react-router-dom";
import {Footer} from "../Body/footer";

export const Checkout = () =>{
    return(
        <div>
            <Menu/>
            <div className="checkout-block container">
                <div className="savatcha-header__routesLink mt-2">
                    <span className="savatcha-header__Link mr-2">
                        <Link to={"/"} className="savatcha-header__HomePageLink">Bosh sahifa</Link>
                    </span>
                    <span className="mr-2">
                        <i className="fa fa-angle-right" color="#9d9d9d"></i>
                    </span>
                    <span className="disabled savatcha-header__Link">
                        <Link to="/savat" className="savatcha-header__SavatchaLink">Savatcha</Link>
                    </span>
                </div>
                <div className="checkout-header mx-auto pt-5 pb-4 px-4 my-5 w-50">
                    <h4 className="mb-4">Buyurtma berish</h4>
                    <div className="form-group mt-2">
                        <label htmlFor="usr" className="checkout-header_label">Telefon raqamingiz</label>
                        <input type="text" className="form-control checkout-header_form-control_input" id="usr"/>
                    </div>
                    <div className="text-center mt-4">
                        <button className="btn checkout-header_form-control_button px-4">Kodni olish</button>
                    </div>
                    <div className="form-check mt-4">
                        <label className="form-check-label">
                            <input type="checkbox" className="form-check-input" value=""/><span className="checkout-header_form-control_span">Saytning <a href="#">qonun-qoidalarini</a> o'qib chiqdim va roziman!</span>
                        </label>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}